import React, {Component} from "react"
import {MenuItem} from "react-bootstrap"
import {FormattedMessage} from "@irati/utils/lang"
import {SchedulerEvent} from "@irati/types"
import MenuActions, {MenuActionsProps} from "../../shared/MenuActions"

interface Props extends Partial<MenuActionsProps> {
  recognition: SchedulerEvent
  onClickRemove: () => void
  viewRecognition: () => void
}

export default class RecognitionActions extends Component<Props> {
  render() {
    const {recognition, onClickRemove, viewRecognition, ...props} = this.props

    return (
      <MenuActions item={recognition} {...props}>
        {() => {
          return [
            <MenuItem key={3} onSelect={viewRecognition}>
              <FormattedMessage id="platform.recognition.popup.recognition.actions.edit" />
            </MenuItem>,
            <MenuItem key={3} onSelect={onClickRemove}>
              <FormattedMessage id="platform.recognition.popup.recognition.actions.delete" />
            </MenuItem>
          ]
        }}
      </MenuActions>
    )
  }
}
